import $http from '../../shared/http';
import Vue from 'vue';

const live_chats = {
  namespaced: true,
  state: () => {
    return {
      hash: '',
    };
  },
  getters: {
    getHash: (state) => state.hash,
    authProfile: (state, getters, rootState, rootGetters) => rootGetters['auth/getAuthProfile'],
    visitorData: (state, getters) => ({
      name: `${getters?.authProfile?.first_name} ${getters?.authProfile?.last_name}`,
      email: getters?.authProfile?.email,
      hash: getters.getHash,
    }),
  },
  mutations: {
    setHash: (state, payload) => (state.hash = payload),
  },
  actions: {
    async loadHash({ commit, getters }) {
      return new Promise(async (resolve, reject) => {
        commit('setHash', '');
        await $http()
          .get('/live-chats/hash')
          .then((response) => {
            commit('setHash', response.data.data);
            Vue.nextTick(() => {
              return resolve(getters.visitorData);
            });
          })
          .catch((error) => {
            commit('setHash', '');
            return reject(error);
          });
      });
    },
  },
};

export default live_chats;
